exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".detailScrollableArea{flex-shrink:1;flex-grow:1;height:984px;flex-basis:100%;overflow-y:scroll;display:flex;flex-direction:column;position:relative}", ""]);

